import type { TabKey } from './types';

const PlaceholderSection = ({ title }: { title: TabKey }) => (
  <div className="rounded-[16px] border border-slate-100 bg-white px-6 py-8 text-sm text-slate-500">
    {title} settings will show here.
  </div>
);

export default PlaceholderSection;
